import css from "@emotion/css";

import {
  FaSpotify,
  FaItunes,
  FaSoundcloud,
  FaBandcamp,
  FaAmazon,
  FaYoutube,
} from "react-icons/fa";

import DeezerIcon from "./deezer-icon";
import { MdFileDownload } from "react-icons/md";
import YouTubeMusicIcon from "./youtube-music-icon";

const ReleaseLinks = ({ release, iconSize }) =>
  release.links ? (
    <div
      css={css`
        margin-top: 8px;
        color: hsla(0, 0%, 0%, 0.5);

        a {
          margin-left: ${8 + 4}px;
          color: unset;
          transition: 0.5s;
        }
        a:first-of-type {
          margin-left: 0;
        }
        a:hover {
          color: hsla(0, 0%, 0%, 0.7);
        }
      `}
    >
      {release.links.spotify && (
        <a
          title="Spotify"
          href={release.links.spotify}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaSpotify size={iconSize} />
        </a>
      )}
      {release.links.appleMusic && (
        <a
          title="Apple Music"
          href={release.links.appleMusic}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaItunes size={iconSize} />
        </a>
      )}
      {release.links.youtubeMusic && (
        <a
          title="YouTube Music"
          href={release.links.youtubeMusic}
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* <FaYoutube size={iconSize} /> */}
          <YouTubeMusicIcon size={iconSize} />
        </a>
      )}
      {release.links.bandcamp && (
        <a
          title="Bandcamp"
          href={release.links.bandcamp}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaBandcamp size={iconSize} />
        </a>
      )}
      {release.links.deezer && (
        <a
          title="Deezer"
          href={release.links.deezer}
          target="_blank"
          rel="noopener noreferrer"
        >
          <DeezerIcon size={iconSize} />
        </a>
      )}
      {release.links.soundcloud && (
        <a
          title="SoundCloud"
          href={release.links.soundcloud}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaSoundcloud size={iconSize} />
        </a>
      )}
      {release.links.amazonMusic && (
        <a
          title="Amazon Music"
          href={release.links.amazonMusic}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaAmazon size={iconSize} />
        </a>
      )}
      {release.links.youtube && (
        <a
          title="YouTube"
          href={release.links.youtube}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaYoutube size={iconSize} />
        </a>
      )}
      {release.links.download && (
        <a
          title="Download"
          href={`/downloads/${release.links.download}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <MdFileDownload size={iconSize} />
        </a>
      )}
    </div>
  ) : null;

export default ReleaseLinks;
